import { defer, LoaderFunction, ShouldRevalidateFunction } from 'react-router-dom'

import { PaginatedResponse } from '@custom-types/response'
import Score from '@models/Score'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type PrivateScoresResponse = { scores: Score[] } & PaginatedResponse

export type MyScoresLoaderResponse = {
  privateScores: Promise<PrivateScoresResponse>
  order: string | null
  filters: string[] | null
}

export const SCORE_PAGE_SIZE = 15

const myScoresLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url)

  const order = url.searchParams.get('order')
  const query = url.searchParams.get('query')
  const filters = url.searchParams.get('filters')?.split(',')
  const privateScores = http.loader.post(ApiRoutes.members.privateScoresPath(), {
    order,
    max_count: SCORE_PAGE_SIZE,
    query,
    filters,
  })
  return defer({ privateScores, order, filters })
}

export default myScoresLoader

export const myScoresRevalidator: ShouldRevalidateFunction = ({ formAction }) => {
  if (formAction === '/home/addCollection') return false
  return true
}
